import {GetConfigFunc} from '../../../types';
import {getPusherSingleton} from './getPusherSingleton';

export const unsubscribeAll = (
  accessToken: string,
  getConfig: GetConfigFunc,
) => {
  const pusher = getPusherSingleton(accessToken, getConfig);
  pusher.allChannels().forEach(c => {
    pusher.unsubscribe(c.name);
  });
};
